const SparkMD5 = require("spark-md5") as {
    hash: (value: string) => string;
};

/**
 * Returns MD5 hash of the given string
 * @param value
 */
export const md5 = (value: string): string => {
    return SparkMD5.hash(value);
};
const SparkMD5 = require("spark-md5") as {
    hash: (value: string) => string;
};

/**
 * Returns MD5 hash of the given string
 * @param value
 */
export const md5 = (value: string): string => {
    return SparkMD5.hash(value);
};
